<template>
  <div
    :class="{
      blocks: !hasSpacingSlices,
      'blocks--no-default-spacing': hasSpacingSlices,
      'blocks--gallery': hasGallery,
    }"
    v-bind="blocksAttributes"
  >
    <component
      :is="getComponent(block._type)"
      v-for="(block, index) in visibleBlocks"
      :id="block._key"
      :key="block._key"
      :block="block"
      :first-block="index === 0"
      :is-home="isHome"
      v-bind="getAttributes(block, index)"
      @in="blockInScreenDetected(index)"
      @out="blockOffScreenDetected(index)"
    />
  </div>
</template>

<script>
import LoadingSlice from '@/components/Slices/Loading'

import ProductsListAutoBlock from '@/blocks/products/ListAuto'
import GalleryOfProductsAndLinks from '@/blocks/products/GalleryOfProductsAndLinks'
import { ORIGIN } from '~/const'

const BLOCKS = {
  productListAutoBlock: ProductsListAutoBlock,
  galleryOfProductsAndLinksBlock: GalleryOfProductsAndLinks,
  productListShopifyCollectionBlock: () => ({
    component: import(
      '@/blocks/products/ListShopify' /* webpackChunkName: 'block_product_list_shopify_collection' */
    ),
    loading: LoadingSlice,
    delay: 0,
  }),
  titleBlock: () => ({
    component: import('@/blocks/Title' /* webpackChunkName: 'block_title' */),
    loading: LoadingSlice,
    delay: 0,
  }),
  textBlock: () => ({
    component: import('@/blocks/Text' /* webpackChunkName: 'block_text' */),
    loading: LoadingSlice,
    delay: 0,
  }),
  simpleContentBlock: () => ({
    component: import(
      '@/blocks/SimpleContent' /* webpackChunkName: 'block_simple_content' */
    ),
    loading: LoadingSlice,
    delay: 0,
  }),

  issueBlock: () => ({
    component: import('@/blocks/Issues' /* webpackChunkName: 'block_issues' */),
    loading: LoadingSlice,
    delay: 0,
  }),
  videoBlock: () => ({
    component: import('@/blocks/Video' /* webpackChunkName: 'block_video' */),
    loading: LoadingSlice,
    delay: 0,
  }),
  tracabiliteBlock: () => ({
    component: import(
      '@/blocks/Tracabilite' /* webpackChunkName: 'block_tracabilite' */
    ),
    loading: LoadingSlice,
    delay: 0,
  }),
  impactBlock: () => ({
    component: import('@/blocks/Impact' /* webpackChunkName: 'block_impact' */),
    loading: LoadingSlice,
    delay: 0,
  }),
  subscribeBlock: () => ({
    component: import(
      '@/blocks/Subscribe' /* webpackChunkName: 'block_subscribe' */
    ),
    loading: LoadingSlice,
    delay: 0,
  }),
  columnBlock: () => ({
    component: import(
      '@/blocks/Columns' /* webpackChunkName: 'block_columns' */
    ),
    loading: LoadingSlice,
    delay: 0,
  }),
  galleryBlock: () => ({
    component: import(
      '@/blocks/Gallery' /* webpackChunkName: 'block_gallery' */
    ),
    loading: LoadingSlice,
    delay: 0,
  }),
  imageFullBlock: () => ({
    component: import(
      '@/blocks/ImageFull' /* webpackChunkName: 'block_image_full' */
    ),
    loading: LoadingSlice,
    delay: 0,
  }),
  mosaicBlock: () => ({
    component: import('@/blocks/Mosaic' /* webpackChunkName: 'block_mosaic' */),
    loading: LoadingSlice,
    delay: 0,
  }),
  quoteBlock: () => ({
    component: import('@/blocks/Quote' /* webpackChunkName: 'block_quote' */),
    loading: LoadingSlice,
    delay: 0,
  }),
  ctaBlock: () => ({
    component: import(
      '@/blocks/CtaText' /* webpackChunkName: 'block_cta_text' */
    ),
    loading: LoadingSlice,
    delay: 0,
  }),
  ctaTextBlock: () => ({
    component: import(
      '@/blocks/CtaText' /* webpackChunkName: 'block_cta_text' */
    ),
    loading: LoadingSlice,
    delay: 0,
  }),
  ctaImageBlock: () => ({
    component: import(
      '@/blocks/CtaImage' /* webpackChunkName: 'block_cta_image' */
    ),
    loading: LoadingSlice,
    delay: 0,
  }),
  assuranceBlock: () => ({
    component: import(
      '@/blocks/Assurance' /* webpackChunkName: 'block_assurance' */
    ),
    loading: LoadingSlice,
    delay: 0,
  }),
  backgroundContentBlock: () => ({
    component: import(
      '@/blocks/BackgroundContent' /* webpackChunkName: 'block_background_content' */
    ),
    loading: LoadingSlice,
    delay: 0,
  }),
  baniereBlock: () => ({
    component: import('@/blocks/Banner' /* webpackChunkName: 'block_banner' */),
    loading: LoadingSlice,
    delay: 0,
  }),
  morphoBlock: () => ({
    component: import('@/blocks/Morpho' /* webpackChunkName: 'block_morpho' */),
    loading: LoadingSlice,
    delay: 0,
  }),
  avisClientBlock: () => ({
    component: import(
      '@/blocks/AvisClient' /* webpackChunkName: 'block_avis_client' */
    ),
    loading: LoadingSlice,
    delay: 0,
  }),
  productTimelineBlock: () => ({
    component: import(
      '@/blocks/ProductTimeline' /* webpackChunkName: 'block_product_timeline' */
    ),
    loading: LoadingSlice,
    delay: 0,
  }),
  productNavBlock: () => ({
    component: import(
      '@/components/blocks/Nav' /* webpackChunkName: 'block_nav' */
    ),
  }),
  spacingBlock: () => ({
    component: import(
      '@/blocks/Spacing' /* webpackChunkName: 'block_spacing' */
    ),
    loading: LoadingSlice,
    delay: 0,
  }),
  tableBlock: () => ({
    component: import('@/blocks/Table' /* webpackChunkName: 'block_table' */),
    loading: LoadingSlice,
    delay: 0,
  }),
  sizeGuideImagesBlock: () => ({
    component: import(
      '@/blocks/SizeGuideImages' /* webpackChunkName: 'block_size_guide_images' */
    ),
    loading: LoadingSlice,
    delay: 0,
  }),
  teasingVideoBlock: () => ({
    component: import(
      '@/blocks/TeasingVideo' /* webpackChunkName: 'block_teasing_video' */
    ),
    loading: LoadingSlice,
    delay: 0,
  }),
  iframeBlock: () => ({
    component: import('@/blocks/Iframe' /* webpackChunkName: 'block_iframe' */),
    loading: LoadingSlice,
    delay: 0,
  }),

  productsImageOrVideoPerColor: () => ({
    component: import(
      '@/blocks/products/ImageOrVideoPerColor' /* webpackChunkName: 'block_product_image_or_video_per_color' */
    ),
    loading: LoadingSlice,
    delay: 0,
  }),

  preOrderExplainBlock: () => ({
    component: import(
      '@/blocks/PreorderExplain' /* webpackChunkName: 'block_preorder_explain' */
    ),
    loading: LoadingSlice,
    delay: 0,
  }),

  impactFairlyBlock: () => ({
    component: import(
      '@/blocks/ImpactFairly' /* webpackChunkName: 'block_impact_fairly' */
    ),
    loading: LoadingSlice,
    delay: 0,
  }),

  testimonialNoteBlock: () => ({
    component: import(
      '@/blocks/TestimonialNote' /* webpackChunkName: 'block_testimonial_note' */
    ),
    loading: LoadingSlice,
    delay: 0,
  }),

  reassuranceBlock: () => ({
    component: import(
      '@/blocks/Reassurance' /* webpackChunkName: 'block_reassurance' */
    ),
    loading: LoadingSlice,
    delay: 0,
  }),

  lineOfOneBlock: () => ({
    component: import(
      '@/blocks/lines/lineOfBlocks' /* webpackChunkName: 'block_line_of_blocks' */
    ),
    loading: LoadingSlice,
    delay: 0,
  }),

  lineOfTwoBlocks: () => ({
    component: import(
      '@/blocks/lines/lineOfBlocks' /* webpackChunkName: 'block_line_of_blocks' */
    ),
    loading: LoadingSlice,
    delay: 0,
  }),

  lineOfThreeBlocks: () => ({
    component: import(
      '@/blocks/lines/lineOfBlocks' /* webpackChunkName: 'block_line_of_blocks' */
    ),
    loading: LoadingSlice,
    delay: 0,
  }),

  countdownBlock: () => ({
    component: import(
      '@/blocks/Countdown' /* webpackChunkName: 'block_countdown' */
    ),
    loading: LoadingSlice,
    delay: 0,
  }),
}

export default {
  name: 'Blocks',
  props: {
    blocks: {
      type: Array,
      required: true,
      default: () => [],
    },
    entities: {
      type: Object,
      default: () => {},
    },
    nav: {
      type: Boolean,
      default: false,
    },
    isHome: {
      type: Boolean,
      default: false,
    },
    isOnTopOfPage: {
      type: Boolean,
      default: false,
    },
    origin: {
      type: String,
      default: ORIGIN.PAGE,
    },
  },
  data: () => ({
    blocksInScreen: [],
    blocksAttributes: {},
  }),
  head() {
    const head = {}
    if (this.isOnTopOfPage && this.visibleBlocks.length > 0) {
      const firstVisibleBlock = this.visibleBlocks[0]

      if (!firstVisibleBlock) {
        return head
      }

      if (['productListAutoBlock'].includes(firstVisibleBlock._type)) {
        head.bodyAttrs = {
          class: this.isHome ? 'home header-transparent' : 'header-transparent',
        }
      }

      if (
        firstVisibleBlock._type === 'productListShopifyCollectionBlock' &&
        !firstVisibleBlock.activate_filters
      ) {
        head.bodyAttrs = {
          class: this.isHome ? 'home header-transparent' : 'header-transparent',
        }
      }

      if (
        firstVisibleBlock._type === 'galleryOfProductsAndLinksBlock' &&
        !firstVisibleBlock.fast_links
      ) {
        head.bodyAttrs = {
          class: this.isHome ? 'home header-transparent' : 'header-transparent',
        }
      }

      if (
        firstVisibleBlock._type === 'baniereBlock' &&
        firstVisibleBlock.image?.image
      ) {
        head.bodyAttrs = {
          class: this.isHome ? 'home header-transparent' : 'header-transparent',
        }
      }

      if (
        firstVisibleBlock._type === 'videoBlock' &&
        firstVisibleBlock.type === 'bunny' &&
        firstVisibleBlock.is_full
      ) {
        head.bodyAttrs = {
          class: this.isHome ? 'home header-transparent' : 'header-transparent',
        }
      }

      if (firstVisibleBlock._type === 'teasingVideoBlock') {
        head.bodyAttrs = {
          class: this.isHome ? 'home header-transparent' : 'header-transparent',
        }
      }
    }

    return head
  },
  computed: {
    visibleBlocks() {
      const bb = this.blocks.filter((block) => {
        if (!BLOCKS[block._type]) {
          console.warn(`Block type ${block._type} is not supported`)
          return false
        }

        if (
          ['testimonialNoteBlock', 'avisClientBlock'].includes(block._type) &&
          !this.entities?.productDocument
        ) {
          console.warn(`No product document found for ${block._type}`)
          return false
        }

        return block.visibility !== null
          ? block.visibility
          : block.defaultVisibility
      })

      if (this.nav) {
        bb.splice(0, 0, { _key: 'product_nav-1', _type: 'productNavBlock' })
      }

      return bb
    },
    hasSpacingSlices() {
      return this.visibleBlocks.some((block) => block._type === 'spacingBlock')
    },
    hasGallery() {
      return this.blocks.some((block) =>
        ['lineOfOneBlock', 'lineOfTwoBlocks', 'lineOfThreeBlocks'].includes(
          block._type
        )
      )
    },
  },
  methods: {
    getComponent(type) {
      return BLOCKS[type]
    },
    getAttributes(block) {
      const attr = {}

      if (block._type === 'productsImageOrVideoPerColor') {
        return {
          ...attr,
          selectedColor: this.entities?.selectedColor,
        }
      }

      if (block._type === 'avisClientBlock' && this.entities?.productDocument) {
        return {
          ...attr,
          uid: this.entities.productDocument.uid,
          average: this.entities.productDocument.rating_average,
        }
      }

      if (block._type === 'productNavBlock' && this.entities) {
        return {
          ...attr,
          blocks: this.visibleBlocks,
          blocksInScreen: this.blocksInScreen,
          productDocument: this.entities.productDocument,
        }
      }

      if (
        block._type === 'testimonialNoteBlock' &&
        this.entities?.productDocument
      ) {
        return {
          ...attr,
          productDocument: this.entities.productDocument,
        }
      }

      if (
        block._type === 'lineOfOneBlock' ||
        block._type === 'lineOfTwoBlocks' ||
        block._type === 'lineOfThreeBlocks'
      ) {
        return {
          ...attr,
          entities: this.entities,
          isHome: this.isHome,
          isOnTopOfPage: this.isOnTopOfPage,
          origin: this.origin,
        }
      }

      return attr
    },
    blockInScreenDetected(index) {
      if (!this.blocksInScreen.includes(index)) {
        this.blocksInScreen.push(index)
      }
    },
    blockOffScreenDetected(index) {
      const i = this.blocksInScreen.indexOf(index)
      this.blocksInScreen.splice(i, 1)
    },
  },
}
</script>

<style lang="scss">
.blocks {
  > .slice,
  > .slice.skeleton {
    margin-bottom: calc(var(--spacing) * 3);

    @include mq($from: tablet) {
      margin-bottom: calc(var(--spacing) * 6);
    }
  }

  > .slice {
    &:first-child {
      margin-top: rem($spacing * 2);

      @include mq($from: tablet) {
        margin-top: rem($spacing * 6);
      }

      &.slice--baniere,
      &.slice--video-bunny.slice--video-full,
      &.slice--products,
      &.slice--image-full,
      &.slice--teasing-video,
      &.block--line-of-blocks {
        margin-top: 0;
      }
    }

    &:last-child {
      &.slice--products--grid,
      &.slice--multi-cta-image,
      &.slice--cta-image,
      &.block--line-of-blocks {
        margin-bottom: 0;
      }
    }
  }

  .slice.skeleton,
  .slice--purchase,
  .slice--background-content,
  .slice--media-content,
  .slice--nav,
  .block--image-or-video-per-color,
  .slice--typeform {
    &:first-child {
      margin-top: 0;
    }

    &:last-child {
      margin-bottom: 0;
    }
  }

  .slice--our-mission {
    margin-bottom: rem($spacing * 4);

    @include mq($from: tablet) {
      margin-top: rem($spacing * 10);
      margin-bottom: rem($spacing * 10);
    }
  }

  .slice--collection-list {
    + .slice--description.only-button {
      margin-top: rem(-$spacing);

      @include mq($from: tablet) {
        margin-top: rem(-$spacing * 6);
      }
    }
  }

  .slice--products {
    + .slice--products {
      margin-top: calc(var(--spacing) * -3);

      @include mq($from: tablet) {
        margin-top: calc(var(--spacing) * -6);
      }

      &.with-title,
      &.slice--products--fast-links {
        margin-top: 0;

        @include mq($from: tablet) {
          margin-top: 0;
        }
      }
    }

    + .slice--quote {
      margin-top: calc(var(--spacing) * -2);

      @include mq($from: tablet) {
        margin-top: calc(var(--spacing) * -5);
      }
    }

    &.full {
      + .slice--products {
        margin-top: 0;
      }
    }
  }

  .slice--products-two-cols {
    + .slice--products {
      margin-top: calc(var(--spacing) * -3);
    }
  }

  .slice--title {
    h1,
    h2,
    h3,
    h4,
    h5 {
      margin-bottom: 0;
    }

    + .slice--simple-content {
      margin-top: calc(var(--spacing) * -1);

      @include mq($from: tablet) {
        margin-top: calc(var(--spacing) * -2);
      }
    }

    + .slice--texte {
      margin-top: calc(var(--spacing) * -2);

      @include mq($from: tablet) {
        margin-top: calc(var(--spacing) * -4);
      }
    }
  }

  .slice--simple-content {
    + .slice--traceability {
      @include mq($from: tablet) {
        margin-top: rem($spacing * 8);
      }
    }
  }

  .slice--video {
    @include mq($from: tablet) {
      margin-bottom: rem($spacing * 8);
    }

    + .slice--products {
      margin-top: calc(var(--spacing) * -2.8);

      @include mq($from: tablet) {
        margin-top: calc(var(--spacing) * -7.8);
      }
    }
  }

  .slice--purchase,
  .slice--issues {
    margin-bottom: rem($spacing * 4);

    @include mq($from: tablet) {
      margin-bottom: rem($spacing * 12);
    }
  }

  .slice--purchase {
    + .slice--issues,
    + .slice--nav {
      margin-top: rem(-$spacing * 4);

      @include mq($from: tablet) {
        margin-top: rem(-$spacing * 12);
      }
    }
  }

  .slice--traceability,
  .slice--impacts {
    margin-bottom: rem($spacing * 4);

    @include mq($from: tablet) {
      margin-bottom: rem($spacing * 8);
    }
  }

  .slice--background-content {
    &:last-child {
      margin-bottom: 0;
    }
  }

  .slice--description {
    + .slice--collection-list,
    + .slice--product-bar {
      margin-top: rem(-$spacing);

      @include mq($from: tablet) {
        margin-top: rem(-$spacing * 2);
      }
    }

    + .slice--product-list {
      margin-top: rem(-$spacing * 2);

      @include mq($from: tablet) {
        margin-top: rem(-$spacing * 3);
      }
    }
  }

  .slice--product-bar {
    + .slice--products {
      margin-top: calc(var(--spacing) * -2);

      @include mq($from: tablet) {
        margin-top: calc(var(--spacing) * -4);
      }
    }
  }

  .slice--button-background {
    &:last-child {
      margin-bottom: 0;
    }
  }

  .slice--size-guide {
    margin-bottom: rem($spacing * 3);

    @include mq($from: tablet) {
      margin-top: rem(-$spacing * 3);
    }
  }

  .slice--texte {
    + .slice--countdown {
      margin-top: rem(-$spacing * 2);

      @include mq($from: tablet) {
        margin-top: rem(-$spacing * 4);
      }
    }
  }

  .slice--countdown {
    + .slice--texte {
      margin-top: rem(-$spacing * 2);

      @include mq($from: tablet) {
        margin-top: rem(-$spacing * 4);
      }
    }

    + .slice--products--auto.slice--products--grid {
      margin-top: rem(-$spacing * 2.8);
    }
  }

  .slice--image-full:not(.container) {
    + .slice--texte {
      margin-top: rem(-$spacing * 2);

      @include mq($from: tablet) {
        margin-top: rem(-$spacing * 4);
      }
    }

    + .slice--image-full {
      margin-top: rem(-$spacing * 2);

      @include mq($from: tablet) {
        margin-top: rem(-$spacing * 4);
      }

      &.image-height-auto {
        margin-top: rem(-$spacing * 3);

        @include mq($from: tablet) {
          margin-top: rem(-$spacing * 6);
        }
      }
    }
  }

  .slice--baniere {
    margin-bottom: rem($spacing * 3);

    + .slice--countdown {
      margin-top: rem(-$spacing * 2);
    }

    &:not(.with-title) + .slice--products--auto {
      margin-top: calc(var(--spacing) * -2.8);
    }

    + .slice--products--fast-links {
      @include mq($until: tablet) {
        margin-top: calc(var(--spacing) * -0.8);
      }
    }
  }

  .slice--products--auto.slice--products--grid + .slice--baniere {
    margin-top: calc(var(--spacing) * -2.6);

    @include mq($from: tablet) {
      margin-top: calc(var(--spacing) * -5.6);
    }
  }

  .slice--gallery {
    + .slice--alert-subscribe.side-by-side {
      @include mq($until: tablet) {
        margin-top: calc(var(--spacing) * -3);
      }
    }
  }

  .slice--alert-subscribe.side-by-side {
    + .slice--gallery {
      @include mq($until: tablet) {
        margin-top: calc(var(--spacing) * -3);
      }
    }
  }

  .block--line-of-blocks {
    margin: 0;
  }

  &__create-alert {
    position: absolute;
    left: 50%;
    z-index: 3;
    bottom: 20%;
    transform: translateX(-50%);
    max-width: rem(510px);
    width: 100%;
    text-align: center;
    padding: 0 var(--spacing);

    .icon {
      margin: 0 auto calc(var(--spacing) * 2);
      color: var(--secondary-color);

      @include mq($from: tablet) {
        margin: 0 auto calc(var(--spacing) * 3);
      }
    }

    .inner {
      padding: calc(var(--spacing) * 2);
      background: var(--secondary-color);
      color: var(--tertiary-color);
    }

    .create-alert__title {
      font-size: var(--h4-font-size);
    }

    form {
      max-width: rem(360px);
      margin: 0 auto;
    }

    .input__line {
      background: $yellow;
      height: rem(3px);
      max-width: calc(100% - #{rem(1px)});
    }

    .action {
      width: 100%;
      margin-top: rem($spacing);

      @include mq($from: tablet) {
        height: rem(45px);
        padding: 0;
      }
    }
  }
}
</style>
